<app-uni-page [parent]="this" pageTitle="In-Process: Process Bins" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate">
</app-uni-page>

<ng-template #bodyTemplate>
  <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[50, 50]">
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full overflow-hidden">
        <div class="flex justify-between items-center mr-4 my-2 shrink-0">
          <div class="flex items-center gap-4">
            <div class="flex items-center">
              <p-checkbox
                inputId="shouldShowClosedBins"
                [(ngModel)]="shouldShowClosedBins"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="refreshAndUpdate()"
                [binary]="true"
              >
              </p-checkbox>
              <label for="shouldShowClosedBins" class="ml-2">Show Closed Bins</label>
            </div>

            <p-floatlabel variant="in">
              <p-select
                [options]="addonStations"
                [(ngModel)]="selectedAddonStationId"
                (ngModelChange)="refreshAndUpdate()"
                optionValue="id"
                optionLabel="name"
              />
              <label for="in_label">Show Station</label>
            </p-floatlabel>

            <p-floatlabel variant="in">
              <p-select
                [options]="refreshOptions"
                [(ngModel)]="refreshSeconds"
                (ngModelChange)="setupRefresh()"
                optionValue="refreshSeconds"
                optionLabel="name"
              />
              <label for="in_label">Refresh Page</label>
            </p-floatlabel>

            <div *ngIf="showRefreshIcon">
              <i class="fa-duotone fa-solid fa-arrows-rotate"></i>
            </div>

            <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-sort-numeric-up" [disabled]="selectedBinCount === 0" (click)="onSetPriority()">
              <span>Set Priority for {{ selectedBinCount }} Bin{{ selectedBinCount !== 1 ? 's' : '' }}</span>
            </button>
          </div>
          <div class="flex items-center gap-2">
            <button *ngIf="this.uow.hasChanges()" pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-check" (click)="saveChanges()">
              <span>Save</span>
            </button>
            <button *ngIf="this.uow.hasChanges()" pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-undo" (click)="cancelChanges()">
              <span>Undo</span>
            </button>
          </div>
        </div>
        <app-ag-grid [gridOptions]="addonBinGridOptions" [rowData]="addonBins" class="flex-1 min-h-0"></app-ag-grid>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full">
        <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[33, 67]">
          <ng-template pTemplate>
            <div class="flex flex-col w-full h-full overflow-hidden">
              <app-ag-grid
                [gridOptions]="addonGridOptions"
                [hasFooter]="false"
                [rowData]="addons"
                class="flex-1 min-h-0 mt-1 mb-1"
              ></app-ag-grid>
            </div>
          </ng-template>
          <ng-template pTemplate>
            <div class="flex flex-col w-full h-full overflow-hidden">
              <app-ag-grid [gridOptions]="itemDetailGridOptions" [rowData]="itemDetails" class="flex-1 min-h-0 mt-1"></app-ag-grid>
            </div>
          </ng-template>
        </p-splitter>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons flex items-center gap-4">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
    <p-progressSpinner *ngIf="isBusy()" ariaLabel="loading" [style]="{ width: '30px', height: '30px' }" />
  </div>
</ng-template>
